// extracted by mini-css-extract-plugin
module.exports = {"root":"Document_root__SZD5d","heading":"Document_heading__qdpAL"};